// extracted by mini-css-extract-plugin
module.exports = {"screenWrap":"index_screenWrap_2Kb84"};